import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "@fontsource-variable/bricolage-grotesque";
import "@fontsource-variable/figtree";
import "@/styles/globals.css";
import { App } from "@/App";
import { queryClient } from "@/lib/query-client";
import { bootstrapConfig } from "@/lib/config";

const container = document.getElementById("root");
if (!container) throw new Error("Wurzelelement #root fehlt in index.html");

// Erst die Konfiguration, dann rendern: sonst entscheidet der erste Bildschirm
// anhand eines leeren Standes, ob es eine Anmeldung gibt.
await bootstrapConfig();

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);

// Service Worker nur im Produktionsbündel, damit der Entwicklungsserver
// nicht gegen einen alten Cache läuft.
if (import.meta.env.PROD) {
  void import("@/lib/pwa").then(({ setupPwa }) => {
    setupPwa((applyUpdate) => {
      // Eigener Streifen statt window.confirm: Der blockierte die Seite und
      // wurde weggetippt, womit die neue Fassung liegen blieb.
      const halter = document.createElement("div");
      document.body.appendChild(halter);
      void import("@/components/UpdateToast").then(({ UpdateToast }) => {
        createRoot(halter).render(<UpdateToast onApply={applyUpdate} />);
      });
    });
  });
}
